import Plug from "../assets/images/plug.svg";
import Speech from "../assets/images/speech.svg";
import Document from "../assets/images/document.svg";
import Exclaim from "../assets/images/exclaim.svg";
import Flame from "../assets/images/flame.svg";
import Calendar from "../assets/images/calendar.svg";

export const getIconSelector = (variant: string): string => {
  let image;
  switch (variant) {
    case "exclaim":
      image = Exclaim;
      break;
    case "speech":
      image = Speech;
      break;
    case "document":
      image = Document;
      break;
    case "flame":
      image = Flame;
      break;
    case "calendar":
      image = Calendar;
      break;
    default:
      image = Plug;
  }
  return image;
};
